import { render, staticRenderFns } from "./DealerEditForm.vue?vue&type=template&id=53925689&"
import script from "./DealerEditForm.vue?vue&type=script&lang=js&"
export * from "./DealerEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports